import { createPortal } from 'react-dom'
import { Toaster } from 'sonner'

export const AppToaster = () =>
  createPortal(<Toaster position="bottom-right" closeButton richColors />, document.body)
